import { LegalLayout } from "./layout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="March 23, 2026">
      <p>
        At Lerni, we take your privacy seriously. This policy explains what information we collect, how we use it, and the choices you have.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information when you use Lerni:</p>
      <ul>
        <li><strong>Account information:</strong> Your name and email address when you register.</li>
        <li><strong>Uploaded content:</strong> Files and text you submit for processing (PDFs, notes, or pasted text).</li>
        <li><strong>Usage data:</strong> How you interact with the service — such as sessions created, characters used, and features accessed.</li>
        <li><strong>Authentication data:</strong> If you sign in with Google, we receive your name and email address from Google.</li>
        <li><strong>Payment data:</strong> Subscription and billing information, handled by Polar. We do not store your full card details.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To create and manage your account.</li>
        <li>To process your uploaded files and generate study materials using AI.</li>
        <li>To enforce usage limits and manage your subscription plan.</li>
        <li>To send transactional emails (such as email verification codes).</li>
        <li>To improve the reliability and quality of our service.</li>
      </ul>

      <h2>3. Third-Party Services</h2>
      <p>Lerni relies on the following third-party services to operate:</p>
      <ul>
        <li><strong>AI processing:</strong> Uploaded content is sent to AI model providers to generate summaries, flashcards, and other study outputs.</li>
        <li><strong>Google OAuth:</strong> If you choose to sign in with Google, your authentication is handled by Google's identity platform.</li>
        <li><strong>Resend:</strong> We use Resend to deliver transactional emails such as verification codes.</li>
        <li><strong>Polar:</strong> Subscription billing and payment processing is handled by Polar.</li>
      </ul>
      <p>Each of these providers has their own privacy policy governing how they handle data.</p>

      <h2>4. Data Retention</h2>
      <p>
        Uploaded files are processed to generate study content and may be stored temporarily to support features like Lerni Bot chat. We do not permanently archive the raw files you upload beyond what is necessary to deliver the service. You may delete your sessions at any time, which removes the associated content from our systems.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We apply reasonable technical safeguards to protect your information, including encrypted connections (HTTPS) and access controls. No system is completely immune to breaches, but we take your security seriously and take steps to mitigate risk.
      </p>

      <h2>6. We Do Not Sell Your Data</h2>
      <p>
        We do not sell, rent, or trade your personal information to third parties for marketing or any other commercial purposes.
      </p>

      <h2>7. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal information we hold about you.</li>
        <li>Request correction of inaccurate data.</li>
        <li>Request deletion of your account and associated data.</li>
      </ul>
      <p>
        To exercise any of these rights, contact us at <strong>lernisupport@gmail.com</strong>.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. If we make significant changes, we will notify you via email or a notice on the platform. Continued use of Lerni after changes are posted means you accept the updated policy.
      </p>

      <h2>9. Contact</h2>
      <p>
        For any privacy-related questions, please reach out to us at <strong>lernisupport@gmail.com</strong>.
      </p>
    </LegalLayout>
  );
}
